//export const URI_DEFAULT = "ws://14.232.214.186:9090/chat"
export const URI_DEFAULT = "wss://drivermanagechat-tw.eupfin.com:9090/chat"
//export const URI_DEFAULT = "ws://localhost:9090/chat";

export const appType = {
    FMS: 1,
    EDRIVER: 2
}
